import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
  setFocus,
} from "@noriginmedia/norigin-spatial-navigation"
import React from "react"

import useTranslate from "../../../hooks/use-translate"
import { appStore } from "../../../store/AppStore"
import { comb } from "../../../utilities/common"
import { s } from "../../../utilities/common"
import { OnboardingButton } from "../../Onboarding/components/OnboardingButton"

export const ConsentButtons = ({
  open,
  returnFocus,
  scrollFn,
  onClose,
}: {
  open: comb<boolean>
  returnFocus: string
  scrollFn: (y: number) => void
  onClose?: () => void
}) => {
  const setTracking = appStore((state) => state.setTracking)
  const t = useTranslate()
  const { ref, focusKey } = useFocusable({
    onFocus: ({ top: y }, __, query) => {
      if (!(query && query.noScroll)) scrollFn(y)
    },
  })
  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        sx={{
          mb: s("60px"),
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          "& > :not(:last-child)": {
            mr: s("22px"),
          },
        }}
      >
        <OnboardingButton
          sx={{ height: s("98px") }}
          text={t("tracking__consent_accept_all")}
          onEnterPress={() => {
            setTracking({ type: "mux", value: true })
            setTracking({ type: "mixpanel", value: true })
            setFocus(returnFocus)
            open.set(false)
            onClose?.()
          }}
        />
        <OnboardingButton
          sx={{ height: s("98px") }}
          text={t("tracking__consent_reject_all")}
          onEnterPress={() => {
            setTracking({ type: "mux", value: false })
            setTracking({ type: "mixpanel", value: false })
            setFocus(returnFocus)
            open.set(false)
            onClose?.()
          }}
        />
      </Box>
    </FocusContext.Provider>
  )
}
